// Products come back from the backend with category = null, so the category menu
// can't filter. This infers a taxonomy category from the product name. The returned
// names match the backend category names exactly, so the sidebar tree + coverage
// filter work. If the backend ever sends a real category, that takes precedence.

const RULES: Array<[RegExp, string]> = [
  // Frozen (must beat cheese/berries/veg below)
  [/\bice ?cream\b|\bfrozen\b/i, "Frozen Foods"],
  // Beverages (juice must beat orange; drink/tea/coffee/water/cola)
  [/\bjuice\b|\bcoffee\b|\btea\b|\bwater\b|\bcola\b|\bsoda\b|\blemonade\b|\bdrink\b/i, "Beverages"],
  // Bakery sweets (cookie/cake/croissant/muffin must beat chocolate/berry/butter)
  [/\bcookie|biscuit/i, "Cookies & Biscuits"],
  [/\bcake|pastry|pastries\b/i, "Cakes & Pastries"],
  [/\bcroissant|muffin|bun|bagel|donut|doughnut\b/i, "Bakery Snacks"],
  [/\bbread|baguette|loaf\b/i, "Bread"],
  // Snacks & confectionery (chip/nuts/granola/chocolate/candy/popcorn)
  [/\bchip|crisps|nuts?\b|granola|chocolate|candy|popcorn|confection/i, "Snacks & Confectionery"],
  // Meat & seafood
  [/\bchicken|beef|steak|pork|lamb|mutton|meat|bacon|sausage|salmon|prawn|shrimp|fish|tuna|seafood\b/i, "Meat & Seafood"],
  // Dairy & eggs
  [/\bmilk\b/i, "Milk & Milk Alternatives"],
  [/\bcheese\b/i, "Cheese"],
  [/\byogh?urt\b/i, "Yogurt"],
  [/\bbutter|margarine\b/i, "Butter & Margarine"],
  [/\begg\b|\beggs\b/i, "Eggs"],
  // Pantry staples
  [/\brice\b|lentil|flour|pasta|spaghetti|noodle|\boil\b|sugar|\bsalt\b|beans?\b|cereal|oats/i, "Pantry Staples"],
  // Fruits
  [/\bapple/i, "Apples"],
  [/\bbanana/i, "Bananas"],
  [/\borange|lemon|lime|grapefruit|citrus\b/i, "Citrus"],
  [/\bberry|berries|blueberr|strawberr|raspberr/i, "Berries"],
  [/\bmango|pineapple|papaya|tropical\b/i, "Tropical Fruits"],
  [/\bgrape|melon|watermelon|kiwi|pear|peach|plum|fruit\b/i, "Fruits"],
  // Vegetables
  [/\bspinach|lettuce|kale|leafy|greens?\b/i, "Leafy Greens"],
  [/\bbroccoli|cauliflower|cabbage|cruciferous\b/i, "Cruciferous"],
  [/\bcarrot|potato|onion|beet|radish|turnip|ginger|garlic\b/i, "Root Vegetables"],
  [/\btomato|cucumber|pepper|capsicum|zucchini|eggplant|vegetable\b/i, "Other Vegetables"],
  // Other departments
  [/\bbaby|infant|diaper|kids?\b/i, "Baby & Kids"],
  [/\bsoap|detergent|cleaner|clean|shampoo|household|personal care|tissue\b/i, "Household & Personal Care"],
];

export function inferCategory(name: string): string | undefined {
  const n = String(name || "");
  for (const [re, cat] of RULES) if (re.test(n)) return cat;
  return undefined;
}
